<template>
  <div class="dashboard-container">
    <h2>系统功能导航</h2>

    <div class="function-grid">
      <el-card class="function-card" shadow="hover" @click="$router.push('/orders')">
        <div class="card-icon">
          <el-icon><document /></el-icon>
        </div>
        <div class="card-title">订单资料</div>
        <div class="card-desc">销售订单管理</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/purchase/orders')">
        <div class="card-icon" style="color: #67C23A;">
          <el-icon><shopping-cart /></el-icon>
        </div>
        <div class="card-title">采购资料</div>
        <div class="card-desc">采购订单管理</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/inventory/material-inventory')">
        <div class="card-icon" style="color: #E6A23C;">
          <el-icon><box /></el-icon>
        </div>
        <div class="card-title">库存资料</div>
        <div class="card-desc">库存查询与管理</div>
      </el-card>

      <el-card
        v-if="showBillingCard"
        class="function-card"
        shadow="hover"
        @click="$router.push('/billing/statements/receivable')"
      >
        <div class="card-icon" style="color: #F56C6C;">
          <el-icon><money /></el-icon>
        </div>
        <div class="card-title">账单资料</div>
        <div class="card-desc">月结/现金账单、应收应付对账</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/inventory/inventory-transactions')">
        <div class="card-icon" style="color: #909399;">
          <el-icon><data-analysis /></el-icon>
        </div>
        <div class="card-title">库存交易报表</div>
        <div class="card-desc">库存交易记录与统计</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/purchase/material-processing-relations')">
        <div class="card-icon" style="color: #FF9900;">
          <el-icon><connection /></el-icon>
        </div>
        <div class="card-title">加工关系</div>
        <div class="card-desc">材料加工关系维护</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/basic-data')">
        <div class="card-icon" style="color: #53a8ff;">
          <el-icon><setting /></el-icon>
        </div>
        <div class="card-title">基础资料</div>
        <div class="card-desc">系统基础设置</div>
      </el-card>

      <el-card
        v-if="showFinanceDocCard"
        class="function-card"
        shadow="hover"
        @click="$router.push('/billing/document-center')"
      >
        <div class="card-icon" style="color: #a0522d;">
          <el-icon><wallet /></el-icon>
        </div>
        <div class="card-title">财务资料</div>
        <div class="card-desc">财务账务管理</div>
      </el-card>

      <el-card
        v-if="showPermissionsCard"
        class="function-card"
        shadow="hover"
        @click="$router.push('/permissions')"
      >
        <div class="card-icon" style="color: #722ed1;">
          <el-icon><user /></el-icon>
        </div>
        <div class="card-title">帐户权限</div>
        <div class="card-desc">用户权限管理</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/quotes')">
        <div class="card-icon" style="color: #13c2c2;">
          <el-icon><price-tag /></el-icon>
        </div>
        <div class="card-title">报价资料</div>
        <div class="card-desc">客户报价管理</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/tasks')">
        <div class="card-icon" style="color: #eb2f96;">
          <el-icon><star /></el-icon>
        </div>
        <div class="card-title">任务中心</div>
        <div class="card-desc">查看待办与提醒</div>
      </el-card>

      <el-card class="function-card" shadow="hover" @click="$router.push('/products')">
        <div class="card-icon" style="color: #52c41a;">
          <el-icon><goods /></el-icon>
        </div>
        <div class="card-title">产品资料</div>
        <div class="card-desc">产品信息管理</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import {
  Document,
  ShoppingCart,
  Box,
  Money,
  DataAnalysis,
  Connection,
  Setting,
  Wallet,
  User,
  PriceTag,
  Star,
  Goods
} from '@element-plus/icons-vue'
import { useUserStore } from '@/store/user'
import { canViewBillingStatements, hasRawPermission, canManageUsersAndRoles } from '@/utils/permission'

export default {
  name: 'DashboardView',
  components: {
    Document,
    ShoppingCart,
    Box,
    Money,
    DataAnalysis,
    Connection,
    Setting,
    Wallet,
    User,
    PriceTag,
    Star,
    Goods
  },
  setup () {
    const userStore = useUserStore()
    userStore.initFromStorage()
    const showBillingCard = computed(() => canViewBillingStatements(userStore.user))
    const showFinanceDocCard = computed(() => hasRawPermission(userStore.user, 'finance.view'))
    const showPermissionsCard = computed(() => canManageUsersAndRoles(userStore.user))
    return { showBillingCard, showFinanceDocCard, showPermissionsCard }
  }
}
</script>

<style scoped>
/*
 * 关键用 auto-fit + minmax(200px)：网格项默认 min-width:auto，
 * 会按内容固有宽度把 11 张卡排成一行撑爆窗口。
 * 改为固定列数 + minmax(0,1fr)，窗口内一定折行，不出现整页横条。
 */
.dashboard-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 20px;
  overflow-x: hidden;
}

.function-grid {
  margin-top: 20px;
  display: grid;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1400px) {
  .function-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1000px) {
  .function-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .function-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.function-card {
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 140px;
  min-width: 0 !important;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.function-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.function-card :deep(.el-card__body) {
  min-width: 0;
  max-width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 10px;
  overflow: hidden;
}

.card-icon {
  font-size: 36px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-desc {
  font-size: 12px;
  color: #909399;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
